export { default } from './InputSearch'
